export { default } from './InputSearch'
